"use strict";

_BannerFlowApp.filter("bytes", function () {
    return function (bytes, precision) {
        if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) return "N/A";

        if (bytes <= 0) return "0 kB";

        if (typeof precision === "undefined") precision = 1;

        var bytesInKb = 1024;
        if (bytes < bytesInKb) precision = 0;

        var units = ["bytes", "kB", "MB", "GB", "TB", "PB"],
            number = Math.floor(Math.log(bytes) / Math.log(bytesInKb));

        return (
            (bytes / Math.pow(bytesInKb, Math.floor(number))).toFixed(precision) + " " + units[number]
        );
    };
});
_BannerFlowApp.filter("sortSizeFormats", function () {
    return function (input) {
        var ordered = {};
        for (var key in input) {
            ordered[input[key]["width"]] = input[key];
        }
        return ordered;
    };
});

_BannerFlowApp.filter("sortLanguages", function () {
    return function (input) {
        var ordered = {};
        for (var key in input) {
            ordered[input[key]["language"]] = input[key];
        }
        return ordered;
    };
});

_BannerFlowApp.filter("sortLanguagesObj", function () {
    return function (input) {
        var keys = input.concat([]);
        keys.sort(function (a, b) {
            return a.language - b.language;
        });
        return keys;
    };
});

_BannerFlowApp.filter("sortTimeZones", function () {
    return function (input) {
        var ordered = {};
        for (var key in input) {
            ordered[input[key]["text"]] = input[key];
        }
        return ordered;
    };
});

_BannerFlowApp.filter("sortScriptTags", function () {
    return function (input) {
        var ordered = {};
        for (var key in input) {
            ordered[input[key]["sort"]] = input[key];
        }
        return ordered;
    };
});

_BannerFlowApp.filter("percentage", function () {
    return function (input, precision) {
        var rounded = (Math.round(input * 10000) / 100).toFixed(precision || 0);
        if (rounded == NaN) {
            return "";
        }
        var percentage = "" + rounded + "%";
        return percentage;
    };
});

_BannerFlowApp.filter("currencyPro", [
    "$filter",
    function ($filter) {
        return function (input) {
            input = parseFloat(input);
            if (input % 1 === 0) {
                input = input.toFixed(0);
            } else input = input.toFixed(2);

            return "$" + input;
        };
    }
]);

_BannerFlowApp.filter("ellipsis", function ($timeout) {
    return function (input, length) {
        var str = input;
        length = length || 50;
        if (!str) return "";
        if (str.length > parseInt(length)) {
            return str.substr(0, parseInt(length)) + "...";
        } else {
            return str;
        }
    };
});

_BannerFlowApp.filter("capitalize", function () {
    return function (input, all) {
        return !!input
            ? input.replace(/([^\W_]+[^\s-]*) */g, function (txt) {
                  return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
              })
            : "";
    };
});

_BannerFlowApp.filter("sentenceCase", function () {
    return function (input, all) {
        return !!input
            ? input.replace(/(^\w{1}|\.\s*\w{1})/gi, function (txt) {
                  return txt.toUpperCase();
              })
            : "";
    };
});

_BannerFlowApp.filter("htmlToPlaintext", function () {
    return function (text) {
        return $("<div/>").html(text).text();
    };
});

_BannerFlowApp.filter("toHtmlText", [
    "$sce",
    function ($sce) {
        return function (htmlCode) {
            htmlCode = htmlCode || "";
            return $sce.trustAsHtml(htmlCode.replace(/\n|\r/gi, "<br>"));
        };
    }
]);

_BannerFlowApp.filter("orderObjectBy", function () {
    return function (items, field, reverse) {
        var filtered = [];
        angular.forEach(items, function (item) {
            filtered.push(item);
        });
        filtered.sort(function (a, b) {
            return a[field] > b[field] ? 1 : -1;
        });
        if (reverse) filtered.reverse();
        return filtered;
    };
});

_BannerFlowApp.filter("orderNumberBy", function () {
    return function (items, field, reverse) {
        var filtered = [];
        angular.forEach(items, function (item) {
            filtered.push(item);
        });
        filtered.sort(function (a, b) {
            return a[field] - b[field];
        });
        if (reverse) filtered.reverse();
    };
});

_BannerFlowApp.filter("regexReplace", function () {
    return function (input, expression, replacement, flag) {
        var regex = new RegExp(expression, flag || "g");
        if (!input) return "";
        return input.replace(regex, replacement);
        if (matches) return matches[0];
        return "";
    };
});

_BannerFlowApp.filter("momentDate", [
    "$filter",
    function ($filter) {
        return function (input, pattern) {
            if (!pattern) pattern = "D MMM YYYY HH:mm";

            if (moment.isMoment(input)) {
                return input.format(pattern);
            } else {
                return moment(input).format(pattern);
            }
        };
    }
]);

_BannerFlowApp.filter("truncate", function () {
    return function (input, max) {
        return input && input.length > max ? input.substr(0, max) + "..." : input;
    };
});
_BannerFlowApp.filter("formatImpressions", function () {
    return function (input) {
        var n = input,
            c = isNaN((c = Math.abs(c))) ? 2 : c,
            d = d == undefined ? "." : d,
            t = t == undefined ? "," : t,
            s = n < 0 ? "-" : "",
            i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
            j = (j = i.length) > 3 ? j % 3 : 0;
        return (
            s +
            (j ? i.substr(0, j) + t : "") +
            i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
            (c
                ? d +
                  Math.abs(n - i)
                      .toFixed(c)
                      .slice(2)
                : ""
            ).split(".")[0]
        );
    };
});
_BannerFlowApp.filter("urlToDomain", function () {
    return function (input) {
        if (!input) return "";

        var n = input.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n]+)/im)[1];
        n = n.match(/\?/) ? n.split("?")[0] : n;

        return n;
    };
});

_BannerFlowApp.filter("htmlSafe", [
    "$sce",
    function ($sce) {
        return $sce.trustAsHtml;
    }
]);

_BannerFlowApp.filter("stripHtml", function () {
    return function (html) {
        var tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    };
});
